export type PoiType = "stream" | "bluff" | "hollow" | "trail" | "bridge" | "other"

export type POI = {
    name: string
    description?: string
    side?: "left" | "right"
    type: PoiType
    coord: {
        longitude: number
        latitude: number
    }
}

export const riverPointsOfInterest: POI[] = [
    //
    //
    //  BOXLEY
    //
    //
    {
        name: "Beech Creek",
        type: "stream",
        coord: {
            longitude: -93.40413207147544,
            latitude: 35.966693887762
        },
        side: "left"
    },
    {
        name: "Arrington Creek",
        type: "stream",
        coord: {
            longitude: -93.39671659830482,
            latitude: 35.97285669638062
        },
        side: "right"
    },
    {
        name: "Moore Creek",
        type: "stream",
        coord: {
            longitude: -93.3984521,
            latitude: 35.9784253
        },
        side: "left"
    },
    {
        name: "Running Creek",
        type: "stream",
        coord: {
            longitude: -93.36706685723016,
            latitude: 36.00289073181584, 
        },
        side: "right"
    },
    {
        name: "Dry Creek",
        type: "stream",
        coord: {
            longitude: -93.3684230,
            latitude: 36.0028134
        },
        side: "right"
    },
    {
        name: "Clark Creek",
        type: "stream",
        coord: {
            longitude: -93.36426217908686,
            latitude: 36.006586066905925, 
        },
        side: "left"
    },
    {
        name: "Cave",
        type: "other",
        coord: {
            longitude: -93.34720041583458,
            latitude: 36.04145913640002, 
        },
        side: "left"
    },
    //
    //
    //  PONCA
    //
    //
    //
    {
        name: "Ponca Creek",
        type: "stream",
        coord: {
            longitude: -93.3551329,
            latitude: 36.0211616
        },
        side: "left"
    },
    {
        name: "Leatherwood Creek",
        type: "stream",
        coord: {
            longitude: -93.3544884,
            latitude: 36.0216763
        },
        side: "right"
    },
    {
        name: "Bee Bluff",
        type: "bluff",
        coord: {
            longitude: -93.3442286,
            latitude: 36.0346972
        },
        side: "right"
    },
    {
        name: "Wrecking Rock",
        type: "other",
        coord: {
            longitude: -93.34808013151131,
            latitude: 36.03755875647062, 
        },
        side: "left"
    },
    {
        name: "Roark Bluff",
        type: "bluff",
        coord: {
            longitude: -93.34234876476924,
            latitude: 36.0438383004652, 
        },
        side: "left"
    },
    //
    //
    //
    //  STEEL CREEK
    //
    //
    //
    {
        name: "Steel Creek",
        type: "stream",
        coord: {
            longitude: -93.3341969,
            latitude: 36.0386682
        },
        side: "right"
    },
    {
        name: "Big Bluff",
        type: "bluff",
        coord: {
            longitude: -93.3207317,
            latitude: 36.0512736
        },
        side: "left"
    },
    {
        name: "Beech Creek",
        type: "stream",
        coord: {
            longitude: -93.3188952,
            latitude: 36.0421718
        },
        side: "right"
    },
    {
        name: "Jackies Big Hollow",
        type: "hollow",
        coord: {
            longitude: -93.3136445,
            latitude: 36.0446001
        },
        side: "right"
    },
    {
        name: "Jim Bluff",
        type: "bluff",
        coord: {
            longitude: -93.3150028,
            latitude: 36.0547340
        },
        side: "left"
    },
    {
        name: "Sneeds Creek Trail",
        type: "trail",
        coord: {
            longitude: -93.3120307,
            latitude: 36.0556094
        },
        side: "left"
    },
    {
        name: "Sneeds Creek",
        type: "stream",
        coord: {
            longitude: -93.3090105,
            latitude: 36.0586977
        },
        side: "left"
    },
    {
        name: "Hemmed-in Hollow Trail",
        type: "trail",
        coord: {
            longitude: -93.3069750,
            latitude: 36.0638037
        },
        side: "left"
    },
    {
        name: "Fishtrap Hollow",
        type: "hollow",
        coord: {
            longitude: -93.3026631,
            latitude: 36.0613371
        },
        side: "left"
    },
    {
        name: "Homestead Remains",
        type: "other",
        coord: {
            longitude: -93.30314297942193,
            latitude: 36.060006698636165,
        },
        side: "left"
    },
    {
        name: "Bear Cave Hollow",
        type: "hollow",
        coord: {
            longitude: -93.2985848,
            latitude: 36.0567484
        },
        side: "left"
    },
    {
        name: "Indian Creek",
        type: "stream",
        coord: {
            longitude: -93.2860305,
            latitude: 36.0492265
        },
        side: "right"
    },
    {
        name: "Large Rock",
        type: "other",
        coord: {
            longitude: -93.2865762,
            latitude: 36.0501486
        },
        side: "left"
    },
    {
        name: "Bear Creek",
        type: "stream",
        coord: {
            longitude: -93.2823479,
            latitude: 36.0562535
        },
        side: "right"
    },
    //
    //
    //
    //  KYLES LANDING
    //
    //
    //
    //
    {
        name: "Castle Rock",
        type: "other",
        coord: {
            longitude: -93.27514701009558,
            latitude: 36.05650654922516,
        },
        side: "left"
    },
    {
        name: "Buzzard Bluff",
        type: "bluff",
        coord: {
            longitude: -93.2676497,
            latitude: 36.0512395
        },
        side: "right"
    },
    {
        name: "Cecil Hollow",
        type: "hollow",
        coord: {
            longitude: -93.2695156,
            latitude: 36.0585353
        },
        side: "left"
    },
    {
        name: "Gar Hole Bluff",
        type: "bluff",
        coord: {
            longitude: -93.2687471,
            latitude: 36.0612753
        },
        side: "left"
    },
    {
        name: "Shop Creek",
        type: "stream",
        coord: {
            longitude: -93.2543038,
            latitude: 36.0591129
        },
        side: "right"
    },
    {
        name: "Dry Creek",
        type: "stream",
        coord: {
            longitude: -93.2540416,
            latitude: 36.0592951
        },
        side: "right"
    },
    {
        name: "Goat Bluff",
        type: "bluff",
        coord: {
            longitude: -93.23525693809925,
            latitude: 36.07605541923039,
        },
        side: "left"
    },
    {
        name: "Cove Creek",
        type: "stream",
        coord: {
            longitude: -93.2258297,
            latitude: 36.0753969
        },
        side: "left"
    },
    {
        name: "Low-water Bridge",
        type: "bridge",
        coord: {
            longitude: -93.2246956,
            latitude: 36.0754314
        },
    },
    {
        name: "Webb Branch",
        type: "stream",
        coord: {
            longitude: -93.2220364,
            latitude: 36.0751770
        },
        side: "right"
    },
    //
    //
    //  ERBIE
    //
    //
    //
    {
        name: "Sawmill Hollow",
        type: "hollow",
        coord: {
            longitude: -93.18625241410571,
            latitude: 36.0561643119314,
        },
        side: "right"
    },
    //
    //
    //  OZARK (PLUS HOSKIN CREEK AND BRIAR BLUFF)
    //
    //
    {
        name: "Hoskin Creek",
        type: "stream",
        coord: {
            longitude: -93.1605000,
            latitude: 36.0651624
        },
        side: "left"
    },
    {
        name: "Briar Bluff",
        type: "bluff",
        coord: {
            longitude: -93.1589073,
            latitude: 36.0655881
        },
        side: "left"
    },
    {
        name: "HWY 7 Bridge",
        type: "bridge",
        coord: {
            longitude: -93.1375549,
            latitude: 36.0609298
        },
    },
    //
    //
    //
    //  PRUITT LANDING
    //
    //
    {
        name: "Mill Creek",
        type: "stream",
        coord: {
            longitude: -93.1326333,
            latitude: 36.0587389
        },
        side: "left"
    },
    {
        name: "Welch Bluff",
        type: "bluff",
        coord: {
            longitude: -93.1262078,
            latitude: 36.0642640
        },
        side: "left"
    },
    {
        name: "Boomer Hollow",
        type: "hollow",
        coord: {
            longitude: -93.1051332,
            latitude: 36.0397766
        },
        side: "left"
    },
    {
        name: "Little Buffalo River",
        type: "stream",
        coord: {
            longitude: -93.1077259,
            latitude: 36.0326520
        },
        side: "right"
    },
    {
        name: "Wells Creek",
        type: "stream",
        coord: {
            longitude: -93.10182805662538,
            latitude: 36.02429728609575,
        },
        side: "left"
    },
    {
        name: "Bear Cave Hollow",
        type: "hollow",
        coord: {
            longitude: -93.1025359,
            latitude: 36.0216596
        },
        side: "right"
    },
    {
        name: "Gray Bluff",
        type: "bluff",
        coord: {
            longitude: -93.10081921979656,
            latitude: 36.00874731418905,
        },
        side: "right"
    },
    //
    //
    //
    //  HASTY (plus chimney rock bluff below too)
    //
    //
    //
    {
        name: "Chimney Rock Bluff",
        type: "bluff",
        coord: {
            longitude: -93.0800332,
            latitude: 36.0084204
        },
        side: "left"
    },
    {
        name: "Hasty Bridge",
        type: "bridge",
        coord: {
            longitude: -93.0812556,
            latitude: 36.0049448
        },
    },
    {
        name: "Rock Creek",
        type: "stream",
        coord: {
            longitude: -93.0824638,
            latitude: 36.0008344
        },
        side: "right"
    },
    {
        name: "Sheldon Branch",
        type: "stream",
        coord: {
            longitude: -93.0799188,
            latitude: 35.9940460
        },
        side: "right"
    },
    {
        name: "Stillhouse Hollow",
        type: "hollow",
        coord: {
            longitude: -93.0575968,
            latitude: 35.9893214
        },
        side: "left"
    },
    {
        name: "Elm Spring Hollow",
        type: "hollow",
        coord: {
            longitude: -93.0580828,
            latitude: 35.9841366
        },
        side: "right"
    },
    {
        name: "HWY 123 Bridge",
        type: "bridge",
        coord: {
            longitude: -93.04262502517288,
            latitude: 35.98337643188298,
        },
    },
    //
    //
    //  CARVER (plus Big Creek is there too)
    //
    //
    //
    {
        name: "Big Creek",
        type: "stream",
        coord: {
            longitude: -93.0409153,
            latitude: 35.9821356
        },
        side: "right"
    },
    {
        name: "Hancock Hollow",
        type: "hollow",
        coord: {
            longitude: -93.0193917,
            latitude: 35.9902895
        },
        side: "left"
    },
    {
        name: "Lick Creek",
        type: "stream",
        coord: {
            longitude: -93.0002075,
            latitude: 35.9956928
        },
        side: "right"
    },
    {
        name: "Ed Clair Hollow",
        type: "hollow",
        coord: {
            longitude: -92.9804216,
            latitude: 35.9961263
        },
        side: "right"
    },
    //
    //
    //
    //  MT HERSEY
    //
    //
    //
    {
        name: "Davis Creek",
        type: "stream",
        coord: {
            longitude: -92.9531812,
            latitude: 36.0088822
        },
        side: "left"
    },
    {
        name: "Mill Branch",
        type: "stream",
        coord: {
            longitude: -92.9523130,
            latitude: 36.0093350
        },
        side: "left"
    },
    {
        name: "Copper Bluff",
        type: "bluff",
        coord: {
            longitude: -92.9482792,
            latitude: 36.0043723
        },
        side: "left"
    },
    {
        name: "Clair Bluff",
        type: "bluff",
        coord: {
            longitude: -92.9567037,
            latitude: 35.9824039
        },
        side: "right"
    },
    {
        name: "Cave Creek",
        type: "stream",
        coord: {
            longitude: -92.9519463,
            latitude: 35.9829001
        },
        side: "right"
    },
    {
        name: "John Reddell Bluff",
        type: "bluff",
        coord: {
            longitude: -92.9373541,
            latitude: 35.9923746
        },
        side: "left"
    },
    {
        name: "Sweet Gum Hollow",
        type: "hollow",
        coord: {
            longitude: -92.9311971,
            latitude: 35.9883397
        },
        side: "left"
    },
    {
        name: "Cane Branch",
        type: "stream",
        coord: {
            longitude: -92.93169970487747,
            latitude: 35.9876411586479,
        },
        side: "left"
    },
    {
        name: "Cane Bluff",
        type: "bluff",
        coord: {
            longitude: -92.9279461,
            latitude: 35.9782074
        },
        side: "left"
    },
    {
        name: "The Narrows",
        type: "other",
        coord: {
            longitude: -92.9015033,
            latitude: 35.9664231
        },
        side: "right"
    },
    {
        name: "Skull Bluff (Bat House)",
        type: "bluff",
        coord: {
            longitude: -92.9003419,
            latitude: 35.9706531
        },
        side: "right"
    },
    {
        name: "Roughedge Hollow",
        type: "hollow",
        coord: {
            longitude: -92.9049311,
            latitude: 35.9739370
        },
        side: "left"
    },
    {
        name: "Benton Bluff",
        description: "Named after artist Thomas Hart Benton.",
        type: "bluff",
        coord: {
            longitude: -92.9030448,
            latitude: 35.9767262
        },
        side: "left"
    },
    //
    //
    //  WOOLUM
    //
    //
    //
    {
        name: "Richland Creek",
        type: "stream",
        coord: {
            longitude: -92.8870888,
            latitude: 35.9698082
        },
        side: "right"
    },
    {
        name: "Jamison Creek",
        type: "stream",
        coord: {
            longitude: -92.8617892,
            latitude: 35.9791737
        },
        side: "left"
    },
    {
        name: "Jamison Bluff",
        type: "bluff",
        coord: {
            longitude: -92.8602904,
            latitude: 35.9784671
        },
        side: "left"
    }, 
    {
        name: "Ben Branch",
        type: "stream",
        coord: {
            longitude: -92.8615965,
            latitude: 35.9593176
        },
        side: "right"
    },
    {
        name: "Manes Bluff",
        type: "bluff",
        coord: {
            longitude: -92.8546511,
            latitude: 35.9571248
        },
        side: "right"
    },
    //
    //
    //  Margaret White Access
    //
    //
    //
    {
        name: "White Bluff",
        type: "bluff",
        coord: {
            longitude: -92.8437639,
            latitude: 35.9720254
        },
        side: "left"
    },
    {
        name: "Crabtree Bluff",
        type: "bluff",
        coord: {
            longitude: -92.8316157,
            latitude: 35.9626941
        },
        side: "left"
    },
    {
        name: "Slay Branch",
        type: "stream",
        coord: {
            longitude: -92.8343825,
            latitude: 35.9549300
        },
        side: "right"
    },
    {
        name: "Whisenant Hollow",
        type: "hollow",
        coord: {
            longitude: -92.8302192,
            latitude: 35.9525984
        },
        side: "right"
    },
    {
        name: "Whisenant Bluff",
        type: "bluff",
        coord: {
            longitude: -92.8270509,
            latitude: 35.9532604
        },
        side: "right"
    },
    {
        name: "Buzzard Roost Bluff",
        type: "bluff",
        coord: {
            longitude: -92.8263899,
            latitude: 35.9653374
        },
        side: "left"
    },
    {
        name: "Peter Cave Bluff",
        type: "bluff",
        coord: {
            longitude: -92.8036033,
            latitude: 35.9627364
        },
        side: "right"
    },
    {
        name: "Rocky Hollow Creek",
        type: "stream",
        coord: {
            longitude: -92.8178311,
            latitude: 35.9739718
        },
        side: "left"
    },
    {
        name: "Red Bluff",
        type: "bluff",
        coord: {
            longitude: -92.8176074,
            latitude: 35.9781756
        },
        side: "left"
    },
    //
    //
    //  baker ford
    //
    //
    //
    {
        name: "McRaven Bluff",
        type: "bluff",
        coord: {
            longitude: -92.7950967,
            latitude: 35.9755081
        },
        side: "right"
    },
    {
        name: "Calf Creek",
        type: "stream",
        coord: {
            longitude: -92.7729757,
            latitude: 35.9792537
        },
        side: "right"
    },
    {
        name: "Mill Creek",
        type: "stream",
        coord: {
            longitude: -92.7673803,
            latitude: 35.9898365
        },
        side: "left"
    },
    //
    //
    //
    //  tyler bend
    //
    //
    //
    //
    {
        name: "HWY 65 Bridge",
        type: "bridge",
        coord: {
            longitude: -92.7476377,
            latitude: 35.9832355
        },
    },
    //
    //
    //
    //  grinders ferry
    //
    //
    //
    {
        name: "Goodhue Hollow",
        type: "hollow",
        coord: {
            longitude: -92.7377783,
            latitude: 35.9844469
        },
        side: "right"
    },
    {
        name: "Dry Creek",
        type: "stream",
        coord: {
            longitude: -92.7181555,
            latitude: 35.9851194
        },
        side: "left"
    },
    //
    //
    //
    //  gilbert
    //
    //
    //
    {
        name: "Bear Creek",
        type: "stream",
        coord: {
            longitude: -92.7008366,
            latitude: 35.9961836
        },
        side: "right"
    },
    {
        name: "Brush Creek",
        type: "stream",
        coord: {
            longitude: -92.6891640,
            latitude: 35.9997455
        },
        side: "right"
    },
    {
        name: "Red Bluff",
        type: "bluff",
        coord: {
            longitude: -92.6848844,
            latitude: 36.0124230
        },
        side: "left"
    },
    {
        name: "Tomahawk Creek",
        type: "stream",
        coord: {
            longitude: -92.6718575,
            latitude: 36.0217042
        },
        side: "left"
    },
    {
        name: "Rocky Creek",
        type: "stream",
        coord: {
            longitude: -92.6409500,
            latitude: 36.0184817
        },
        side: "right"
    },
    {
        name: "Little Rocky Creek",
        type: "stream",
        coord: {
            longitude: -92.6380433,
            latitude: 36.0122182
        },
        side: "right"
    },
    //
    //
    //
    // maumee north
    //
    //
    //
    {
        name: "Spring Branch",
        type: "stream",
        coord: {
            longitude: -92.6362419,
            latitude: 36.0378214
        },
        side: "left"
    },
    //
    //
    //
    // maumee south
    //
    //
    //
    {
        name: "Spring Creek",
        type: "stream",
        coord: {
            longitude: -92.5894134,
            latitude: 36.0206004
        },
        side: "right"
    },
    {
        name: "Spring Creek Bluff",
        type: "bluff",
        coord: {
            longitude: -92.5888317,
            latitude: 36.0222226
        },
        side: "right"
    },
    //
    //
    //
    // spring creek
    //
    //
    //
    {
        name: "Jackpot Bluff",
        type: "bluff",
        coord: {
            longitude: -92.5975491,
            latitude: 36.0354797
        },
        side: "left"
    },
    {
        name: "Stairstep Bluff",
        type: "bluff",
        coord: {
            longitude: -92.5768229,
            latitude: 36.0439874
        },
        side: "right"
    },
    {
        name: "Kimball Creek",
        type: "stream",
        coord: {
            longitude: -92.5756970,
            latitude: 36.0482150
        },
        side: "right"
    },
    {
        name: "Water Creek",
        type: "stream",
        coord: {
            longitude: -92.5764289,
            latitude: 36.0498105
        },
        side: "left"
    },
    {
        name: "Kimball Bluff",
        type: "bluff",
        coord: {
            longitude: -92.5749270,
            latitude: 36.0534006
        },
        side: "right"
    },
    {
        name: "HWY 14 Bridge",
        type: "bridge",
        coord: {
            longitude: -92.5775568,
            latitude: 36.0673617
        }
    },
    //
    //
    //
    //  dillards ferry hwy 14
    //
    //
    //
    //
    {
        name: "Jim Hollow",
        type: "hollow",
        coord: {
            longitude: -92.5761098,
            latitude: 36.0679860
        },
        side: "left"
    },
    {
        name: "Hogskin Hollow",
        type: "hollow",
        coord: {
            longitude: -92.5689158,
            latitude: 36.0682203
        },
        side: "left"
    },
    {
        name: "Skull Rock",
        type: "other",
        coord: {
            longitude: -92.5605628,
            latitude: 36.0705439
        },
        side: "left"
    },
    {
        name: "Rock Creek",
        type: "stream",
        coord: {
            longitude: -92.5566835,
            latitude: 36.0678875
        },
        side: "right"
    },
    {
        name: "Painted Bluff",
        type: "bluff",
        coord: {
            longitude: -92.5532048,
            latitude: 36.0694055
        },
        side: "right"
    },
    //
    //
    //
    //
    //  buffalo point
    //
    //
    //
    //
    {
        name: "Hickory Creek",
        type: "stream",
        coord: {
            longitude: -92.5539928,
            latitude: 36.0720320
        },
        side: "right"
    },
    {
        name: "Panther Creek",
        type: "stream",
        coord: {
            longitude: -92.5553575,
            latitude: 36.0856280
        },
        side: "left"
    },
    {
        name: "Ingram Creek",
        type: "stream",
        coord: {
            longitude: -92.5419812,
            latitude: 36.0810566
        },
        side: "right"
    },
    {
        name: "Devil's Tea Table",
        type: "other",
        coord: {
            longitude: -92.5394306,
            latitude: 36.0825374
        },
        side: "right"
    },
    {
        name: "Toney Bluff",
        type: "bluff",
        coord: {
            longitude: -92.5484997,
            latitude: 36.0995313
        },
        side: "left"
    },
    {
        name: "Jones Hollow",
        type: "hollow",
        coord: {
            longitude: -92.5342807,
            latitude: 36.1004606
        },
        side: "right"
    },
    {
        name: "Ludlow Bluff",
        type: "bluff",
        coord: {
            longitude: -92.5302765,
            latitude: 36.1064154
        },
        side: "right"
    },
    {
        name: "Gage Bluff",
        type: "bluff",
        coord: {
            longitude: -92.5576716,
            latitude: 36.1154634
        },
        side: "left"
    },
    {
        name: "Rush Creek",
        type: "stream",
        coord: {
            longitude: -92.5491048,
            latitude: 36.1242212
        },
        side: "left"
    },
    //
    //
    //
    //
    //  RUSH
    //
    //
    //
    //
    {
        name: "Clabber Creek",
        type: "stream",
        coord: {
            longitude: -92.5452671,
            latitude: 36.1277708
        },
        side: "left"
    },
    {
        name: "Silver Hollow",
        type: "hollow",
        coord: {
            longitude: -92.5372518,
            latitude: 36.1217974
        },
        side: "right"
    },
    {
        name: "Silver Hollow Bluff",
        type: "bluff",
        coord: {
            longitude: -92.5329579,
            latitude: 36.1202943
        },
        side: "right"
    },
    {
        name: "Cabin Creek",
        type: "stream",
        coord: {
            longitude: -92.5274095,
            latitude: 36.1265502
        },
        side: "left"
    },
    {
        name: "Cedar Creek",
        type: "stream",
        coord: {
            longitude: -92.5135819,
            latitude: 36.1320048
        },
        side: "left"
    },
    {
        name: "Boat Creek",
        type: "stream",
        coord: {
            longitude: -92.5108455,
            latitude: 36.1307261
        },
        side: "left"
    },
    {
        name: "Lonely Hollow Bluff",
        type: "bluff",
        coord: {
            longitude: -92.5191128,
            latitude: 36.1059721
        },
        side: "right"
    },
    {
        name: "Lonely Hollow",
        type: "hollow",
        coord: {
            longitude: -92.5072826,
            latitude: 36.1111238
        },
        side: "right"
    },
    {
        name: "Rough Hollow",
        type: "hollow",
        coord: {
            longitude: -92.4987856,
            latitude: 36.1032964
        },
        side: "left"
    },
    {
        name: "Fishtrap Creek",
        type: "stream",
        coord: {
            longitude: -92.4992741,
            latitude: 36.0947290
        },
        side: "right"
    },
    {
        name: "Slick Rock Creek",
        type: "stream",
        coord: {
            longitude: -92.4793988,
            latitude: 36.0804218
        },
        side: "right"
    },
    {
        name: "Big Creek",
        type: "stream",
        coord: {
            longitude: -92.4731961,
            latitude: 36.0790270
        },
        side: "right"
    },
    {
        name: "Cold Spring Hollow",
        type: "hollow",
        coord: {
            longitude: -92.4688197,
            latitude: 36.0812590
        },
        side: "right"
    },
    {
        name: "Bear Hollow",
        type: "hollow",
        coord: {
            longitude: -92.4530618,
            latitude: 36.0988815
        },
        side: "left"
    },
    {
        name: "Bear Bluff",
        type: "bluff",
        coord: {
            longitude: -92.4447246,
            latitude: 36.0971602
        },
        side: "left"
    },
    {
        name: "Caney Branch",
        type: "stream",
        coord: {
            longitude: -92.4434300,
            latitude: 36.0885706
        },
        side: "right"
    },
    {
        name: "Middle Creek",
        type: "stream",
        coord: {
            longitude: -92.4288198,
            latitude: 36.0855517
        },
        side: "right"
    },
    {
        name: "Short Creek",
        type: "stream",
        coord: {
            longitude: -92.4265697,
            latitude: 36.0908474
        },
        side: "right"
    },
    {
        name: "Spencer Bluff",
        type: "bluff",
        coord: {
            longitude: -92.4386588,
            latitude: 36.0998406
        },
        side: "left"
    },
    {
        name: "Leatherwood Creek",
        type: "stream",
        coord: {
            longitude: -92.4294811,
            latitude: 36.1094342
        },
        side: "right"
    },
    {
        name: "High Burr Bluff",
        type: "bluff",
        coord: {
            longitude: -92.4309040,
            latitude: 36.1143671
        },
        side: "right"
    },
    {
        name: "Sheep Jump Creek",
        type: "stream",
        coord: {
            longitude: -92.4437283,
            latitude: 36.1162188
        },
        side: "left"
    },
    {
        name: "Brush Creek",
        type: "stream",
        coord: {
            longitude: -92.4340605,
            latitude: 36.1256461
        },
        side: "right"
    },
    {
        name: "Cow Creek",
        type: "stream",
        coord: {
            longitude: -92.4316490,
            latitude: 36.1334813
        },
        side: "left"
    },
    {
        name: "Elephant's Head",
        type: "bluff",
        coord: {
            longitude: -92.4280471,
            latitude: 36.1364354
        },
        side: "right"
    },
    {
        name: "Gosha Creek",
        type: "stream",
        coord: {
            longitude: -92.4301098,
            latitude: 36.1407634
        },
        side: "right"
    },
    {
        name: "Stewart Creek",
        type: "stream",
        coord: {
            longitude: -92.4137628,
            latitude: 36.1533788
        },
        side: "right"
    },
    {
        name: "Grayface Bluff",
        type: "bluff",
        coord: {
            longitude: -92.4050477,
            latitude: 36.1536781
        },
        side: "right"
    },
    {
        name: "Cook Hollow",
        type: "hollow",
        coord: {
            longitude: -92.4266468,
            latitude: 36.1621925
        },
        side: "left"
    },
    {
        name: "Confluence of the White and Buffalo Rivers",
        type: "other",
        coord: {
            longitude: -92.4294598,
            latitude: 36.1694974
        },
    },
    {
        name: "Stair Bluff",
        type: "bluff",
        coord: {
            longitude: -92.4357290,
            latitude: 36.1647430
        },
        side: "left"
    }
]